import { useContext, useState, useEffect } from 'react';
import { MyContext } from '../Context/MyProvider';
import Login from './Login/Login';
import secureLocalStorage from 'react-secure-storage';
import { Link, useNavigate } from 'react-router-dom';
import { showToast } from '../showTost';
import axios from 'axios';
import Profile from './page/Profile';
import LocationImg from "../Image/permission.png";
import WebLogo from "../Image/logo.png";
import FooterLogo from "../Image/zupprfooter.png";

const Header = () => {

    const { BaseUrl, showloginpage, setShowLoginPage, isInstallable, setIsInstallable, totalcart, locationsearch, MapKey, setLocationSearch, callHomeApi, setCallHomeApi, adsupdate, islogin } = useContext(MyContext);

    const [addreslist, setAddresList] = useState([]);
    const [saveaddres, setSaveAddres] = useState([]);
    const [inputsearch, setInputSearch] = useState("");
    const [showSaveAddress, setShowSaveAddres] = useState(true);
    const [showLocationBox, setShowLocatiobBox] = useState(false);
    const [showprofile, setShowProfile] = useState(false);
    const [locationError, setLocationError] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);


    const navigate = useNavigate();

    const Userid = secureLocalStorage.getItem("Userid");

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            position => {
                const IsAddedLocation = secureLocalStorage.getItem("Location");
                if (IsAddedLocation) {
                    const { address } = JSON.parse(IsAddedLocation);
                    setInputSearch(address);
                    setLocationSearch(address);
                } else {
                    HandleGetGoogleAddress();
                }
            },
            error => {
                setLocationError(true);
            }
        );

        handleGetAddresList();
    }, [adsupdate, islogin]);


    useEffect(() => {
        const isShowStored = secureLocalStorage.getItem("pwa");

        const shouldShowInstall = isShowStored !== null ? isShowStored : true;
        setIsInstallable(shouldShowInstall);

        if (!shouldShowInstall) return;

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    useEffect(() => {
        if (inputsearch) {
            axios.get(`${BaseUrl}/eapi/mapresponse.php?query=${inputsearch}`)
                .then((res) => {
                    // console.log("Location Search Data :-->>", res.data);
                    setAddresList(res.data.results);
                })
                .catch((error) => {
                    console.error("Location Search Data :-->>", error);
                });
        }
    }, [inputsearch]);

    const handleLogout = () => {
        showToast({ title: "Logout successfuly !!", id: "success" });
        secureLocalStorage.removeItem("Logindata");
        secureLocalStorage.removeItem("Tax");
        secureLocalStorage.removeItem("Tip");
        secureLocalStorage.removeItem("Userid");
        secureLocalStorage.removeItem("currency");
        secureLocalStorage.removeItem("restaurantsid");
        secureLocalStorage.removeItem("localcartdata");
        secureLocalStorage.removeItem("walletamt");
        secureLocalStorage.removeItem("is_dmode");
        sessionStorage.clear();
        window.location.href = "/";
    }

    const handleGetAddresList = () => {
        const uid = secureLocalStorage.getItem("Userid");
        axios.post(`${BaseUrl}/eapi/e_address_list.php`, { uid })
            .then((res) => {
                // console.log("e_address_list.php", res.data.AddressList);
                setSaveAddres(res.data.AddressList);
            })
            .catch((error) => {
                console.error("e_address_list.php", error);
            });
    }

    const handleSelectLocation = (index, data) => {
        const lats = data.geometry?.location.lat || data.lat_map;
        const longs = data.geometry?.location.lng || data.long_map;

        axios.post(`${BaseUrl}/eapi/zone_check.php`, { lats, longs })
            .then((res) => {
                console.log(res);
                if (res.data.ResponseCode == 200) {
                    if (index === 1) {
                        setInputSearch(`${data.hno}, ${data.landmark}, ${data.address}`);
                        setLocationSearch(`${data.hno}, ${data.landmark}, ${data.address}`);
                        const Location = { address: `${data.hno}, ${data.landmark}, ${data.address}`, lat: data.lat_map, long: data.long_map }
                        secureLocalStorage.setItem("Location", JSON.stringify(Location));
                        setCallHomeApi(!callHomeApi);
                    } else {
                        setInputSearch(data.formatted_address);
                        setLocationSearch(data.formatted_address);
                        const Location = { address: data.formatted_address, lat: data.geometry.location.lat, long: data.geometry.location.lng }
                        secureLocalStorage.setItem("Location", JSON.stringify(Location));
                        setCallHomeApi(!callHomeApi);
                    }
                    setShowLocatiobBox(false);
                    navigate("/");
                } else {
                    showToast({ title: "Service is not provided in this area.", id: "info" });
                }
            })
            .catch((error) => {
                console.error("zone_check", error);
            });
    }

    const HandleGetGoogleAddress = async () => {
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const lat = position.coords.latitude;
                const long = position.coords.longitude;
                try {
                    const response = await axios.get(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${MapKey}`
                    );
                    const address = response.data.results[0]?.formatted_address;
                    if (address) {
                        setLocationSearch(address);
                        setInputSearch(address);
                        setShowLocatiobBox(false);
                        const Location = { address: address, lat: "21.2381631", long: "72.8879239" }
                        secureLocalStorage.setItem("Location", JSON.stringify(Location));
                        setCallHomeApi(!callHomeApi);
                    } else {
                        console.warn('No address found for this location.');
                    }
                } catch (error) {
                    console.error('Error fetching address:', error);
                }
            },
            (error) => {
                console.error('Geolocation error:', error);
                showToast({ title: "You have blocked Zuppr from tracking your location. To use this, change your location settings in browser.", id: "info" });
            }
        );
    };

    const HandleLocationEnable = () => {
        showToast({ title: "You have blocked Zuppr from tracking your location. To use this, change your location settings in browser.", id: "warning" });
    }

    const handleSearch = () => {
        const Data = {
            searchtype: 1,
        }
        navigate("/search", { state: Data });
    }

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === "accepted") {
                secureLocalStorage.setItem("pwa", false);
                setDeferredPrompt(null);
                setIsInstallable(false);
            }
        }
    };

    const handleClosePwaCard = () => {
        setIsInstallable(false);
        secureLocalStorage.setItem("pwa", false);
    }

    return (
        <div className="header_page">

            <div className="width_container">
                <div className="header_box max-_430_:gap-[10px]">
                    <div className="left_box">
                        <Link to="/" className="max-_770_:hidden flex items-center gap-[10px]">
                            <img src={WebLogo} className="w-[100px]" alt="WebLogo" />
                        </Link>
                        <div onClick={() => setShowLocatiobBox(!showLocationBox)} className="w-[70%] max-_770_:w-full flex items-center justify-between cursor-pointer">
                            <div className="flex items-center gap-[5px] w-full">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2.25C7.175 2.25 3.25 6.175 3.25 11C3.25 16.118 7.94699 19.2199 11.055 21.2729L11.584 21.624C11.71 21.708 11.855 21.75 12 21.75C12.145 21.75 12.29 21.708 12.416 21.624L12.945 21.2729C16.053 19.2199 20.75 16.118 20.75 11C20.75 6.175 16.825 2.25 12 2.25ZM12.119 20.021L12 20.1001L11.881 20.021C8.871 18.033 4.75 15.311 4.75 11C4.75 7.002 8.002 3.75 12 3.75C15.998 3.75 19.25 7.002 19.25 11C19.25 15.311 15.128 18.034 12.119 20.021ZM12 7.75C10.208 7.75 8.75 9.208 8.75 11C8.75 12.792 10.208 14.25 12 14.25C13.792 14.25 15.25 12.792 15.25 11C15.25 9.208 13.792 7.75 12 7.75ZM12 12.75C11.035 12.75 10.25 11.965 10.25 11C10.25 10.035 11.035 9.25 12 9.25C12.965 9.25 13.75 10.035 13.75 11C13.75 11.965 12.965 12.75 12 12.75Z" fill="white" />
                                </svg>
                                <input readOnly type="text" value={locationsearch || "Enter your delivery location"} className="w-full text-[14px] overflow-ellipsis outline-none bg-transparent border-b pb-[3px]" />
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 16.75C11.808 16.75 11.616 16.6771 11.47 16.5301L4.46999 9.53005C4.17699 9.23705 4.17699 8.76202 4.46999 8.46902C4.76299 8.17602 5.23803 8.17602 5.53103 8.46902L12.001 14.939L18.471 8.46902C18.764 8.17602 19.239 8.17602 19.532 8.46902C19.825 8.76202 19.825 9.23705 19.532 9.53005L12.532 16.5301C12.384 16.6771 12.192 16.75 12 16.75Z" fill="white" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div className="right_box">

                        <div onClick={handleSearch} className='flex items-center gap-[10px] '>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="white" />
                            </svg>
                            <h1 className='border-b-[1px] border-white pb-[3px] pe-[30px] cursor-text max-_995_:hidden max-_1025_:pe-[10px]'>Search restaurant ...</h1>
                        </div>

                        {totalcart !== 0 && <Link to="/checkout" className="relative">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.27 21C10.27 21.69 9.71002 22.25 9.02002 22.25C8.33102 22.25 7.76501 21.69 7.76501 21C7.76501 20.31 8.32001 19.75 9.01001 19.75H9.02002C9.71002 19.75 10.27 20.31 10.27 21ZM17.02 19.75H17.01C16.32 19.75 15.765 20.31 15.765 21C15.765 21.69 16.33 22.25 17.02 22.25C17.71 22.25 18.27 21.69 18.27 21C18.27 20.31 17.71 19.75 17.02 19.75ZM21.705 8.492L20.691 14.658C20.428 16.104 19.774 17.75 17 17.75H8.73401C7.37501 17.75 6.20396 16.735 6.01196 15.389L4.50195 4.82401C4.41395 4.21201 3.88301 3.75101 3.26501 3.75101H3C2.586 3.75101 2.25 3.41501 2.25 3.00101C2.25 2.58701 2.586 2.25101 3 2.25101H3.26599C4.62499 2.25101 5.79604 3.266 5.98804 4.612L6.07996 5.25101H19C19.818 5.25101 20.5881 5.611 21.1121 6.239C21.6351 6.866 21.852 7.688 21.705 8.492ZM19.213 14.403L19.3199 13.75H13C12.586 13.75 12.25 13.414 12.25 13C12.25 12.586 12.586 12.25 13 12.25H19.567L20.2271 8.23599C20.2961 7.85799 20.198 7.484 19.959 7.19901C19.72 6.91401 19.371 6.75 18.999 6.75H6.29297L7.49695 15.177C7.58495 15.789 8.11601 16.25 8.73401 16.25H17C18.597 16.25 18.986 15.654 19.213 14.403Z" fill="white" />
                            </svg>
                            <div className="absolute -top-[8px] -right-[5px]">
                                <div className="rounded-full bg-[--bgcolor] w-[15px] text-center">
                                    <h2 className="text-[14px] font-[500]">{totalcart}</h2>
                                </div>
                            </div>
                        </Link>}

                        <div className="">
                            {Userid
                                ? <div className="user_dropdown_wrapper">

                                    <div className="user_icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                            <path d="M15.7607 11.8897C17.6325 11.8897 19.1488 10.4133 19.1488 8.59205C19.1488 6.77184 17.6325 5.29541 15.7607 5.29541C13.89 5.29541 12.3726 6.77184 12.3726 8.59205C12.3726 10.4133 13.89 11.8897 15.7607 11.8897ZM8.4418 18.8226C9.55113 15.9384 12.4101 13.8843 15.7607 13.8843C19.1131 13.8843 21.9711 15.9384 23.0799 18.8226C23.4596 19.8103 23.6494 20.3041 23.2438 20.8947C22.8381 21.4853 22.1753 21.4853 20.8498 21.4853H10.6717C9.34616 21.4853 8.68342 21.4853 8.27773 20.8947C7.87205 20.304 8.06197 19.8102 8.4418 18.8226Z" fill="#43464A"></path><path d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z" fill="#43464A"></path><path d="M20.449 17.773C23.0101 17.773 25.0849 15.7528 25.0849 13.2608C25.0849 10.7702 23.0101 8.75 20.449 8.75C17.8893 8.75 15.813 10.7702 15.813 13.2608C15.813 15.7528 17.8893 17.773 20.449 17.773ZM10.4354 27.2601C11.9533 23.3136 15.8653 20.5029 20.4498 20.5029C25.037 20.5029 28.9475 23.3136 30.4646 27.26C30.9842 28.6115 31.244 29.2872 30.6889 30.0953C30.1338 30.9034 29.2269 30.9034 27.4132 30.9034H13.4865C11.6729 30.9034 10.766 30.9034 10.2109 30.0952C9.65584 29.2869 9.9157 28.6113 10.4354 27.2601Z" fill="white"></path>
                                        </svg>
                                    </div>

                                    <div className="dropdown_box">
                                        <div className="dropdown_menu">
                                            <button onClick={() => setShowProfile(true)} className="h1">Profile</button>
                                            <button onClick={() => navigate("/orders")} className="h1">Orders</button>
                                            <button onClick={() => navigate("/favorite")} className="h1">Favorite</button>
                                            <button onClick={() => navigate("/offers-near-me")} className="h1">Offers</button>
                                            <button onClick={() => navigate("/wallet")} className="h1">Wallet</button>
                                            <button onClick={() => navigate("/refer-earn")} className="h1">Refer & Earn</button>
                                            <button className="h1" onClick={handleLogout}>Logout</button>
                                        </div>
                                    </div>

                                </div>
                                : <button onClick={() => setShowLoginPage(true)} className="py-[13px] px-[30px] whitespace-nowrap bg-black rounded-[16px] font-bold text-white">Sign in</button>}
                        </div>
                    </div>
                </div>
            </div>

            {isInstallable && <div className="pwa_card">
                <div className="bg-white p-[20px] rounded-[12px]">
                    <div className="flex items-start justify-between">
                        <div className="flex items-center gap-[15px] pb-[10px]">
                            <img src={FooterLogo} className='w-[80px] sm:w-[60px]' alt="logo" />
                            <div className="">
                                <h1 className='font-[500] text-[17px] sm:text-[16px] text-gray-700'>Zuppr</h1>
                                <p className='text-[14px] sm:text-[12px] text-gray-500'>https://zupper.cscodetech.com</p>
                            </div>
                        </div>
                        <button onClick={handleClosePwaCard}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                            </svg>
                        </button>
                    </div>
                    <h1 className='text-[15px] sm:text-[14px] my-[5px] font-[500] text-gray-700'>Install Progressive Web Application</h1>
                    <p className='text-[14px] sm:text-[12px] text-gray-500'>This site has app functionality. Install it on your device for extensive experience and easy access.</p>
                    <div className="w-full flex justify-end mt-[10px]">
                        <button onClick={handleInstallClick} className='font-[500] border-[1px] border-[black] text-black hover:bg-[#000000c4] duration-[.30s] hover:text-white px-[20px] py-[5px] rounded-[10px]'>
                            Install
                        </button>
                    </div>
                </div>
            </div>}

            <div className={`login_model ${showloginpage && "login_model_open"}`}>
                <button onClick={() => setShowLoginPage(false)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                    </svg>
                </button>
                <Login />
            </div>

            <div className={`login_model ${showprofile && "login_model_open"}`}>
                <div className="flex items-center gap-[10px]">
                    <button onClick={() => setShowProfile(false)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                        </svg>
                    </button>
                    <h1 className="text-[20px] font-[500] text-black">Edit Profile</h1>
                </div>
                <Profile />
            </div>

            <div style={{ paddingTop: "0" }} className={`location_model ${showLocationBox && "location_model_open"}`}>
                <div className="w-full flex justify-end mb-[20px]">
                    <div className="location_box">

                        <div className="sticky top-[0px] bg-white pt-[30px] pb-[10px] z-[555]">
                            <div className="w-full flex justify-end mb-[20px]">
                                <button onClick={() => setShowLocatiobBox(false)}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                    </svg>
                                </button>
                            </div>

                            <div className="border-[2px] focus-within:border-[--bgcolor] flex items-center gap-[10px] px-[10px] rounded-[10px]">
                                <svg width="24" height="24" className="text-[--bgcolor]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2.5C7.313 2.5 3.5 6.313 3.5 11C3.5 15.983 8.129 19.041 11.192 21.064L11.722 21.416C11.806 21.472 11.903 21.5 11.999 21.5C12.095 21.5 12.192 21.472 12.276 21.416L12.806 21.064C15.869 19.041 20.498 15.983 20.498 11C20.5 6.313 16.687 2.5 12 2.5ZM12 13.5C10.619 13.5 9.5 12.381 9.5 11C9.5 9.619 10.619 8.5 12 8.5C13.381 8.5 14.5 9.619 14.5 11C14.5 12.381 13.381 13.5 12 13.5Z" fill="currentColor" />
                                </svg>
                                <input type="text" value={inputsearch} onChange={(e) => setInputSearch(e.target.value)} className=" w-full outline-none py-[8px] font-[500] text-gray-600 overflow-ellipsis" placeholder="Enter your delivery location..." />
                            </div>
                        </div>

                        <button onClick={HandleGetGoogleAddress} className="w-full py-[20px] flex items-center gap-[10px]">
                            <svg width="24" height="24" className="text-[--bgcolor]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 11.25H18.96C18.961 11.255 18.96 11.2589 18.961 11.2639C18.618 7.98592 16.015 5.38206 12.737 5.03906C12.741 5.03906 12.746 5.03904 12.75 5.04004V3C12.75 2.59 12.41 2.25 12 2.25C11.59 2.25 11.25 2.59 11.25 3V5.04004C11.254 5.04004 11.259 5.04006 11.263 5.03906C7.985 5.38206 5.382 7.98592 5.039 11.2639C5.04 11.2589 5.03898 11.255 5.03998 11.25H3C2.59 11.25 2.25 11.59 2.25 12C2.25 12.41 2.59 12.75 3 12.75H5.03998C5.03898 12.745 5.04 12.7411 5.039 12.7361C5.382 16.0141 7.986 18.6179 11.263 18.9609C11.259 18.9609 11.254 18.961 11.25 18.96V21C11.25 21.41 11.59 21.75 12 21.75C12.41 21.75 12.75 21.41 12.75 21V18.96C12.746 18.96 12.741 18.9599 12.737 18.9609C16.015 18.6179 18.618 16.0141 18.961 12.7361C18.96 12.7411 18.961 12.745 18.96 12.75H21C21.41 12.75 21.75 12.41 21.75 12C21.75 11.59 21.41 11.25 21 11.25ZM12 14.5C10.619 14.5 9.5 13.381 9.5 12C9.5 10.619 10.619 9.5 12 9.5C13.381 9.5 14.5 10.619 14.5 12C14.5 13.381 13.381 14.5 12 14.5Z" fill="currentColor" />
                            </svg>
                            <h1 className="font-[700] text-[--bgcolor] text-[17px]">Use my current location</h1>
                        </button>

                        {saveaddres?.length >= 1 && <div className="py-[20px] border-t-[1px]">
                            <div className="flex items-center justify-between gap-[20px]">
                                <h1 className="font-[500] text-gray-600">SAVE ADDRESSES</h1>
                                <button onClick={() => setShowSaveAddres(!showSaveAddress)}>
                                    <svg width="20" height="20" className={`${showSaveAddress ? "-rotate-[180deg]" : "rotate-0"} duration-[.3s]`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 17C11.744 17 11.488 16.9021 11.293 16.7071L4.29301 9.70707C3.90201 9.31607 3.90201 8.68401 4.29301 8.29301C4.68401 7.90201 5.31607 7.90201 5.70707 8.29301L12 14.586L18.293 8.29301C18.684 7.90201 19.3161 7.90201 19.7071 8.29301C20.0981 8.68401 20.0981 9.31607 19.7071 9.70707L12.7071 16.7071C12.5121 16.9021 12.256 17 12 17Z" fill="#25314C" />
                                    </svg>
                                </button>
                            </div>
                            {showSaveAddress && <div className="">
                                {saveaddres.map((item, index) => {
                                    return <div key={index} onClick={() => handleSelectLocation(1, item)} className="py-[8px] flex items-center gap-[10px] cursor-pointer group">
                                        <div>
                                            <svg width="20" height="20" className="text-[rgba(2,6,12,.75)]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.894 4.534L13.436 20.3831C13.014 21.2801 11.705 21.174 11.433 20.221L10.343 16.4051C9.96305 15.0761 8.92504 14.038 7.59604 13.658L3.78006 12.5682C2.82706 12.2962 2.72101 10.987 3.61801 10.565L19.467 3.107C20.376 2.678 21.322 3.624 20.894 4.534Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="overflow-hidden leading-5">
                                            <h1 className="font-bold text-[rgba(2,6,12,.75)] group-hover:text-[--bgcolor]">{item.type}</h1>
                                            <p className="text-[rgba(2,6,12,.6)] font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis">{`${item.hno}, ${item.landmark}, ${item.address}`}</p>
                                        </div>
                                    </div>
                                })}
                            </div>}
                        </div>}

                        {inputsearch && <div className="pt-[20px] border-t-[1px]">
                            <h1 className="font-[500] text-gray-600">SEARCH RESULT</h1>

                            <div className="">
                                {addreslist?.map((item, index) => {
                                    return <div key={index} onClick={() => handleSelectLocation(2, item)} className="py-[8px] flex items-center gap-[10px] cursor-pointer group">
                                        <div>
                                            <svg width="20" height="20" className="text-[rgba(2,6,12,.75)]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.894 4.534L13.436 20.3831C13.014 21.2801 11.705 21.174 11.433 20.221L10.343 16.4051C9.96305 15.0761 8.92504 14.038 7.59604 13.658L3.78006 12.5682C2.82706 12.2962 2.72101 10.987 3.61801 10.565L19.467 3.107C20.376 2.678 21.322 3.624 20.894 4.534Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="overflow-hidden leading-5">
                                            <h1 className="font-bold text-[rgba(2,6,12,.75)] overflow-ellipsis whitespace-normal overflow-hidden group-hover:text-[--bgcolor]">{item.name}</h1>
                                            <p className="text-[rgba(2,6,12,.6)] font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis">{item.formatted_address}</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>}

                    </div>
                </div>
            </div>

            {locationError && (<div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                    <div className="text-black">
                        <h2 className="m-0 text-center font-[500] text-[17px]">Enable Location Services</h2>
                        <img src={LocationImg} alt="" />
                        <div className="my-3">
                            <div className="flex gap-[10px]">
                                <span className="text-[18px]">1.</span>
                                <h6>To provide accurate services, please enable your location.</h6>
                            </div>
                            <div className="flex gap-[5px]">
                                <span className="text-[18px]">2.</span>
                                <h6>Allow location access when prompted. If not prompted, enable it in your browser settings.</h6>
                            </div>
                            <h6>🔄 Refresh the page after enabling.</h6>
                        </div>
                        <button onClick={HandleLocationEnable} className="bg-[--bgcolor] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">Enable Now</button>
                    </div>
                </div>
            </div>)}

            {showLocationBox && <div onClick={() => setShowLocatiobBox(false)} className="overlay z-[888]"></div>}
            {showloginpage && <div onClick={() => setShowLoginPage(false)} className="overlay z-[888]"></div>}
            {showprofile && <div onClick={() => setShowProfile(false)} className="overlay z-[888]"></div>}

        </div >
    )
}

export default Header